import { Coins } from "lucide-react";
import { Slider } from "@/components/ui/slider";
import { Switch } from "@/components/ui/switch";
import { STATUS, eur, num, redeemValue } from "@/lib/api";

export const maxPointsFor = (balance, rate, payable) => Math.max(0, Math.min(balance, Math.ceil(+(payable / rate).toFixed(6))));

export const discountFor = (points, rate, payable) => Math.min(redeemValue(points, rate), payable);

export function PointsSelector({ me, payable, enabled, setEnabled, points, setPoints }) {
  if (!me) return null;
  const rate = me.redeem_rate;
  const max = maxPointsFor(me.balance, rate, payable);
  const discount = enabled ? discountFor(points, rate, payable) : 0;
  return (
    <div data-testid="points-selector" className="rounded-2xl border border-amber-500/25 bg-amber-500/5 p-4">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <Coins className="h-5 w-5 text-amber-400" />
          <div>
            <p className="font-semibold text-white">Paga con i punti</p>
            <p className="text-xs text-slate-400">
              Hai {num(me.balance)} pt · {STATUS[me.status].label}: 1.000 pt = {eur(rate * 1000)}
            </p>
          </div>
        </div>
        <Switch
          data-testid="points-toggle"
          checked={enabled}
          disabled={max === 0}
          onCheckedChange={(v) => {
            setEnabled(v);
            setPoints(v ? max : 0);
          }}
        />
      </div>
      {max === 0 && <p className="mt-2 text-xs text-slate-500">Non hai ancora punti da usare: li guadagni con ogni acquisto.</p>}
      {enabled && max > 0 && (
        <div className="mt-4 space-y-2">
          <Slider data-testid="points-slider" value={[points]} min={0} max={max} step={1} onValueChange={(v) => setPoints(v[0])} />
          <div className="flex justify-between text-sm">
            <span className="text-slate-300">Usi <b data-testid="points-used" className="text-amber-300">{num(points)} pt</b></span>
            <span className="text-slate-300">Sconto <b data-testid="points-discount" className="text-emerald-400">−{eur(discount)}</b></span>
          </div>
        </div>
      )}
    </div>
  );
}
